module.exports = __webpack_public_path__ + "static/media/5-wood.eb20a884.png";